/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountOnboardingStep {
    TUTORIAL = 'Tutorial',
    GIFT = 'Gift',
    PRICING = 'Pricing',
    DONE = 'Done',
}
